export default "__VITE_ASSET__DkuDuHhx__"